export default __webpack_public_path__ + "static/media/cloud-upload-blue.64d236d2.svg";